module.exports = __webpack_public_path__ + "static/media/icon_servicios_medicos.db9b4044.svg";